<script lang="ts" setup>
</script>

<template>
  <p>Placeholder text - Search Table View</p>
</template>

<style lang="scss">
</style>
